import React, { createContext, useContext } from 'react';

import { createGlobalStyle } from 'styled-components';

import { IBaseProps } from '@rbi-ctg/frontend';

import useBraze, { IBrazeContext } from './hooks/use-braze';

/**
 * In order to center popups, Braze is using both `margin: auto;` and
 * 50% possitioning and transforms. This results in a visual conflict
 * that causes the modal to be off center. Margin auto is adding margins
 * when they're not needed.
 *
 * TODO: Braze agreed to fix this in Q1 2020. This hack should be unnecessary at some point.
 */
const BrazeCssBugOverrideStyles = createGlobalStyle`
.ab-centering-div .ab-centered, .ab-centering-div.ab-centering-div .ab-modal, .ab-iam-root.v3 .ab-centered, .ab-iam-root.v3.ab-centering-div .ab-modal {
  margin: 0 !important;
  position: relative !important;
}
`;

export const BrazeContext = createContext<IBrazeContext>({} as IBrazeContext);

export const useBrazeContext = () => useContext(BrazeContext);

export const BrazeProvider = ({ children }: IBaseProps) => {
  const ctxValue = useBraze();

  return (
    <BrazeContext.Provider value={ctxValue}>
      <BrazeCssBugOverrideStyles />
      {children}
    </BrazeContext.Provider>
  );
};
